<template>
    <div>
        <b-row align-h="end">
            <b-col
                cols="12"
                md="4"
                lg="3"
                class="d-flex justify-content-end"
                v-if="canSelectMassive"
            >
                <a href="#" @click.prevent="selectAll">Todos</a>
                &nbsp;|&nbsp;
                <a href="#" @click.prevent="selectNone">Ninguno</a>
            </b-col>
        </b-row>
        <app-data-table
            :fields="fields"
            :items="data.data"
            @sort="onSort"
            :current-page="data.current_page"
            :last-page="data.last_page"
            :from="data.from"
            :to="data.to"
            :total="data.total"
            :per-page="data.per_page"
            :on-change-page="onChangePage"
        >
            <template slot="mail_type.name" slot-scope="{ item }">
                <i class="fa" :class="item.mail_type.fa_class"></i>
                {{ item.mail_type.name }}
            </template>

            <template slot="owner.name" slot-scope="{ item }">
                {{ !!item.owner ? item.owner.name : '' }}
            </template>

            <template slot="user.name" slot-scope="{ item }">
                {{ item.user.name | elipsis(18) }}
            </template>

            <template slot="notes" slot-scope="{ item }">
                {{ item.notes | elipsis(20) }}
            </template>

            <template slot="created_at" slot-scope="{ item }">
                {{ item.created_at | datetime }}
            </template>

            <template slot="duration" slot-scope="{ item }">
                {{ item.created_at | duration }}
            </template>

            <template slot="delivery.created_at" slot-scope="{ item }">
                {{ item.delivery.created_at | datetime }}
            </template>

            <template slot="actions" slot-scope="{ item }">
                <b-row>
                    <b-col cols="12" lg="2" class="mr-2">
                        <b-button
                            size="sm"
                            variant="primary"
                            @click="viewMail(item)"
                            ><i class="fa fa-search-plus"></i
                        ></b-button>
                    </b-col>
                    <b-col lg="2">
                        <b-form-checkbox
                            :value="item.id"
                            v-model="selected"
                            switch
                        >
                            Seleccione</b-form-checkbox
                        >
                    </b-col>
                </b-row>
            </template>
        </app-data-table>
    </div>
</template>
<script>
export default {
    props: {
        data: {
            type: Object,
            required: true,
        },
        viewMail: {
            type: Function,
            required: true,
        },
        deliverMail: {
            type: Function,
            required: true,
        },
        onChangePage: {
            type: Function,
            required: true,
        },
        disableDelivery: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            selected: [],
            fields,
        }
    },
    watch: {
        selected() {
            this.$emit('keys', this.selected)
        },
    },
    computed: {
        canSelectMassive() {
            if (!this.data || !this.data.data) return false
            const destinations = this.data.data.map(item => item.destination_id)
            return _.uniq(destinations).length === 1
        },
    },
    methods: {
        onSort(ctx) {
            this.$emit('sort', ctx)
        },
        selectAll() {
            this.data.data.map(item => this.selected.push(item.id))
            this.$emit('keys', this.selected)
        },
        selectNone() {
            this.selected = []
            this.$emit('keys', this.selected)
        },
    },
}

const fields = [
    {
        key: 'mail_type.name',
        label: 'Tipo',
    },
    {
        key: 'destination.name',
        label: 'Destino',
    },
    {
        key: 'owner.name',
        label: 'Para',
    },
    {
        key: 'user.name',
        label: 'Recibido por',
    },
    {
        key: 'created_at',
        label: 'Recibido el',
    },
    {
        key: 'notes',
        label: 'Notas',
    },
    {
        key: 'duration',
        label: 'Duración',
        orderBy: 'created_at',
    },
    {
        key: 'actions',
        label: 'Acciones',
    },
]
</script>
